<template>
  <cReport
    :reportName="reportName"
    :listReportData="lsReportData"
    :listReportTableData="lsReportTableData"
    :lsReportFields="lsReportFields"
    @submit="onGetPeriodicalSalesReport"
    @getProviders="getReportTableFields"
    :defaultFields="defaultFields"
    
  />
</template>

<script>
import cReport from "../../components/report/cReport";
import {
  PATHNAME,
  COMPONENT_NAME,
  ALERT_MODAL_STATUS,
  ORDER,
  DATE_TIME_FORMAT
} from "../../../src/util/constants";
import apiSystemPeriodicalSalesReport from "../../../src/services/apiSystemPeriodicalSalesReport";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import {
  addClassToBody,
  removeClassBody,
  handleJWT,
  getErrorAlertValue,
  cloneDeep,
  cloneData,
  OrderByList
} from "../../../src/util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base.js";
export default {
  name: COMPONENT_NAME.DAILY_OR_PERIODICAL_SALES_REPORT,
  components: {
    cReport
  },
  data: () => {
    return {
      reportName: COMPONENT_NAME.DAILY_OR_PERIODICAL_SALES_REPORT,
      lsReportData: null,
      lsReportTableData: null,
      lsReportFields: [],
      defaultFields: []
    };
  },

  methods: {
    async onGetPeriodicalSalesReport(pReportQuery,pSelProvider) {
      try {
        if (BaseConfiguration.isDebug)
          console.log("onGetPeriodicalSalesReport");
          if (pSelProvider) {
          this.getReportTableFields(pSelProvider);
        }
        this.lsReportData = await this.getPeriodicalSalesReport(
        pReportQuery.fromDate,
            pReportQuery.toDate,
            pReportQuery.lsCurrCode,
            pReportQuery.b2bid,
            pReportQuery.groupId,
            pReportQuery.airlineCode,
            pReportQuery.provider
        );
       if (this.lsReportData && this.lsReportData.report) {
          this.lsReportTableData = this.lsReportData.report;
        }else{
          this.lsReportTableData=[];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.DAILY_OR_PERIODICAL_SALES_REPORT,
          "error in onGetPeriodicalSalesReport",
          err.toString(),
          "onGetPeriodicalSalesReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getPeriodicalSalesReport(
        pFromDate,
      pToDate,
      pLsCurrCode,
      pB2bId,
      pGroupId,
      pAirline,
      pProvider
    ) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPeriodicalSalesReport");

        let systemReportReq = apiSystemPeriodicalSalesReport.buildRequest(
         pFromDate,
          pToDate,
          pB2bId,
          pGroupId,
          pLsCurrCode,
          pAirline,
          pProvider
        );
        if (systemReportReq) {
          let systemReportRes = await apiSystemPeriodicalSalesReport.getResponse(
            systemReportReq
          );

          if (systemReportRes) {
            if (VALIDATE_SUCCESS_RES(systemReportRes)) {
              retValue = systemReportRes.data.data;
            } else {
              retValue = null;
              let error = getErrorMessage(systemReportRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.DAILY_OR_PERIODICAL_SALES_REPORT,
          "error in getPeriodicalSalesReport",
          err.toString(),
          "getPeriodicalSalesReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getReportTableFields(pProviders) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getReportTableFields");

        let defaultFields = [
          {
            key: "b2bcode",
            label: this.$t('cReport.agencyCode'),
                                    isLocked: true

          },

          {
            key: "agencyname",
            label: this.$t('cReport.agencyName'),
                                    isLocked: true

          },
        ];
        retValue = defaultFields;
        this.defaultFields = cloneDeep(defaultFields);
        if (pProviders.constructor == Object) {
          if (pProviders.providerDisplayName != "All") {
            let field = {
              key: pProviders.providerDisplayName,
              label: pProviders.providerDisplayName,
                          isLocked: false

            };
            retValue.push(field);
            this.lsReportFields = retValue;
          }
        } else {
          for (let i = 0; i < pProviders.length; i++) {
            if (pProviders[i].providerDisplayName != "All") {
              let field = {
                key: pProviders[i].providerDisplayName,
                label: pProviders[i].providerDisplayName,
                            isLocked: false

              };
              retValue.push(field);
            }
          }
          this.lsReportFields = retValue;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOPUP_FORECAST_REPORT,
          "error in getReportTableFields",
          err.toString(),
          "getReportTableFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
  computed: {},
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.DAILY_OR_PERIODICAL_SALES_REPORT,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>

<style>
</style>